module.exports = __webpack_public_path__ + "static/media/Map-pin.90b61eea.png";